import styled from "@emotion/styled"
import { BsPlayFill, BsFillPauseFill } from "react-icons/bs"
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi"
import { IoMdMic, IoMdMicOff } from "react-icons/io"
import { MdOutlineLiveTv } from "react-icons/md"

import type { RoomBranding } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
  hideContols?: boolean
  isMobile?: boolean
  isAudioWatchParty?: boolean
  isTablet?: boolean
  isActiveSpeakerBorder?: boolean
  isBorderVideoPlayer?: boolean
  isSafariMobile?: boolean
  isLandscape?: boolean
  isOpenControlsMobile?: boolean
  isModerator?: boolean
  isHost?: boolean
  isOpenControlDesktop?: boolean
  isTabletNoSmallWindows?: boolean
  recordingView?: boolean
  isProductOverlay?: boolean
  isRaiseHandButton?: boolean
  isUseEmojiPump?: boolean
  hideFullControls?: boolean
  isImage?: boolean
  isPanelFS?: boolean
  isTransparent?: boolean
  isLiveControl?: boolean
  showPlayerBarWhenClose?: boolean
}

export const VideoContainer = styled.div<StylesProps>`
  width: 100%;
  border: ${({ isBorderVideoPlayer, roomStyles }) =>
    isBorderVideoPlayer && `2px solid ${roomStyles?.highlighterColor}`};
  position: relative;
  overflow: hidden;
  z-index: 2;
`

// export const Controls = styled.div<StylesProps>`
//   transition: ${({ hideFullControls, isLandscape }) =>
//     !hideFullControls ? "unset" : isLandscape ? "bottom 0.2s" : "all 0.2s"};
//   z-index: 1000000;
//   visibility: ${({ hideContols }) => (hideContols ? "hidden" : "unset")};
//   display: flex;
//   position: absolute;
//   bottom: 0;
//   left: ${({ isLandscape, hideFullControls, isImage }) =>
//     !hideFullControls && !isImage && isLandscape && "50%"};
//   width: "100%";
//   flex-wrap: wrap;
//   transform: 
//   ${({
//     isLandscape,
//     isOpenControlsMobile,
//     isMobile,
//     isHost,
//     isOpenControlDesktop,
//     isTablet,
//     isProductOverlay,
//     hideFullControls,
//     isImage,
//     isLiveControl,
//     showPlayerBarWhenClose
//   }) =>
//     hideFullControls && showPlayerBarWhenClose && isLiveControl // show player bar if showPlayerBarWhenClose is true
//       ? "translateY(100%)"
//       : hideFullControls
//       ? "translateY(100%) translateY(-0px)"
//       : isProductOverlay && isTablet
//       ? "translateY(100%) translateY(-5px)"
//       : isLandscape && isOpenControlsMobile && isMobile
//       ? "translate(-50%) translateY(0px)"
//       : isLandscape && !isOpenControlsMobile && isMobile
//       ? "translate(-50%) translateY(50px)"
//       : // For Live-stream Controls with showPlayerBarWhenClose is true
//       isOpenControlsMobile && isMobile && isLiveControl && showPlayerBarWhenClose
//       ? "translateY(0%)"
//       : isOpenControlsMobile && isMobile && isLiveControl // For Live-stream Controls
//       ? "translateY(100%) translateY(-50px)"
//       : isOpenControlsMobile && isMobile
//       ? "translateY(100%) translateY(-55px)"
//       : !isOpenControlsMobile && isMobile
//       ? "translateY(100%) translateY(-5px)"
//       : (!isMobile && isHost) || (isHost && isTablet)
//       ? "translateY(0)"
//       : isOpenControlDesktop && !isMobile
//       ? "translateY(0)"
//       // Hide player bar on desktop
//       : !isOpenControlDesktop  && !showPlayerBarWhenClose // && isLiveControl
//       ? "translateY(100%) translateY(0px)"
//       : !isOpenControlDesktop && !isMobile
//       ? "translateY(100%) translateY(-5px)"
//       : isOpenControlsMobile
//       ? "translateY(0)"
//       : "translateY(100%) translateY(-5px)"};
// `

export const ContainerIcon = styled.div<StylesProps>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorderOffset ?? "black"};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PlayButton = styled.button<StylesProps>`
  display: flex;
  border: none;
  user-select: none;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder ?? "white"};
  cursor: pointer;
  height: 100%;
  `

export const Volume = styled.input<StylesProps>`
  -webkit-appearance: none;
  background: transparent;
  margin: 0;
  width: 12%;
  padding: 0px;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 10px;
    cursor: pointer;
    background: ${({ roomStyles }) =>
      roomStyles.servicePanelElementBorderOffset ?? "black"};
    border-radius: 0.375rem;
    border: ${({ roomStyles }) =>
      roomStyles?.servicePanelElementBorder
        ? `1px solid ${roomStyles?.servicePanelElementBorder}`
        : "1px solid gray"};
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: ${({ roomStyles }) =>
      roomStyles?.servicePanelElementBorder ?? "orangered"};
    cursor: pointer;
    transform: translateY(100%) translateY(-14px);
  }
`

export const Time = styled.div<StylesProps>`
  margin-left: auto;
  font-size: 1em;
  color: white;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const PauseIcon = styled(BsFillPauseFill)`
  width: 30px;
  height: 30px;
  display: inline-block;
  font-size: 28px;
`
export const PlayIcon = styled(BsPlayFill)`
  width: 30px;
  height: 30px;
  display: inline-block;
  font-size: 28px;
  transform: translateX(1.5px) translateY(0px);
`
export const MuteButton = styled.button<StylesProps>`
  background: transparent;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder ?? "white"};
  border: none;
  position: relative;
  display: flex;
  align-items: center;
  height: 50px;
  justify-content: center;
  height: calc(100% - 10px);
`

export const FullScreenButton = styled(MuteButton)`
  padding: ${({ isLandscape, isPanelFS, isTransparent, isMobile }) =>
    isLandscape
      ? isPanelFS
        ? "0px 8.5px 10px 10px"
        : "0px 12px 10px 10px"
      : isTransparent && isPanelFS
      ? "0px 9.5px 10px 10px"
      : isMobile
      ? "0px 9px 10px 10px"
      : "0px 10px 10px 10px"};
  width: ${({ isPanelFS }) => !isPanelFS && "30.4px"};
  height: ${({ isPanelFS }) => (isPanelFS ? "calc(100% - 10px)" : "30.4px")};
`

export const MuteIcon = styled(HiVolumeOff)`
  width: 22px;
  height: 22px;
  display: inline-block;
  font-size: 22px;
`
export const VolumeIcon = styled(HiVolumeUp)`
  width: 22px;
  height: 22px;
  display: inline-block;
  font-size: 22px;
`

export const MicIcon = styled(IoMdMic)`
  width: 22px;
  height: 22px;
  display: inline-block;
  font-size: 22px;
`

export const MuteMicIcon = styled(IoMdMicOff)`
  width: 22px;
  height: 22px;
  display: inline-block;
  font-size: 22px;
`

export const HeaderContainer = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  // width: 100%;
`
